<template>
  <h3 class="text-center text-gray thin nodata">{{$t('No data')}}</h3>
</template>

<style lang="scss" scoped>
.nodata {
  padding: 75px 0px;
  box-shadow: 0px 0px 30px #0000000d;
  border-radius: 15px;
  margin: 20px 0px;
}
</style>

<script>
export default {};
</script>